<template>
  <div class="home_box">
    <!-- 内容区域 -->
    <div class="main_container">
      <!-- 左侧栏目 -->
      <aside class="sidebar">
        <div class="logo" @click="$router.push('/')">
          <img src="@/assets/logo (2).png" alt="甜筒星球" class="logo_img" />
        </div>
        <!-- 搜索框 -->
        <div class="search_box" @click="Sousuo()">
          <img style="width: 16px; margin-right: 6px;" src="../assets/sousuo2.png" alt="">
          <input type="text" placeholder="搜索内容" class="search_input" />
        </div>

        <!-- 菜单列表 -->
        <ul class="menu_list">
          <li
            v-for="item in menuList"
            :key="item.name"
            :class="['menu_item', { active: activeMenu === item.name }]"
            @click="lanmu(item)"
          >
            <img 
              class="menu_icon" 
              :src="activeMenu === item.name ? item.iconActive : item.icon" 
              alt=""
            >
            <span class="menu_text">{{ item.label }}</span>
          </li>
        </ul>

        <!-- 登陆/充值按钮 -->
        <button 
          v-if="!isLoggedIn" 
          class="sidebar_login_btn" 
          @click="$router.push('/login')"
        >登录</button>
        <button 
          v-else 
          class="sidebar_login_btn" 
          @click="openRecharge"
        >获取甜筒</button>

        <!-- 推荐主播 -->
        <div class="recommend_section">
          <h3 class="section_title">推荐主播</h3>
          <ul class="anchor_list">
            <li v-for="anchor in anchorList" :key="anchor.id" class="anchor_item" @click="TuiJianClick(anchor.anchorid,anchor.id)">
              <div class="anchor_avatar_wrap">
                <img :src="anchor.touxiang" :alt="anchor.name" class="anchor_avatar" />
                <span v-if="anchor.statuss==1" class="live_badge">直播中</span>
              </div>
              <div class="anchor_info">
                <span class="anchor_name">{{ anchor.content }}</span>
                <span class="anchor_subtitle">{{ anchor.anchor_name }}</span>
              </div>
            </li>
          </ul>
        </div>

        <!-- 公司信息 -->
        <div class="company_section">
          <p class="company_copyright">© 2026 北京甜筒星球科技有限公司 版权所有</p>
          <p class="company_copyright">京ICP备2025141949号-1</p>
          <p class="company_copyright">北京市大兴区经济开发区科苑路9号3号楼三层T1389室</p>
        </div>
      </aside>

      <!-- 视图展示区域 -->
      <main class="content">
        <router-view @showMinorProtection="handleShowMinorProtection"></router-view>
      </main>
    </div>

    <!-- 充值弹窗 -->
    <div v-if="vipshow" class="recharge-overlay" @click.self="closeRecharge">
      <div class="recharge-panel">
        <!-- 头部 -->
        <div class="recharge-header">
          <h3 class="recharge-title">获取甜筒·充值</h3>
          <i class="el-icon-close" @click="closeRecharge"></i>
        </div>

        <!-- 充值选项 -->
        <div class="recharge-options">
          <div
            v-for="(item, index) in rechargeList"
            :key="index"
            class="recharge-item"
            :class="{ active: selectedAmount === item.amount }"
            @click="selectAmount(item)"
          >
            <div class="item-left">
              <img src="@/assets/tiantong.png" class="sweet-icon" alt="甜筒" />
              <span class="sweet-count">{{ item.count }}甜筒</span>
            </div>
            <span class="item-price">{{ item.amount }}元</span>
          </div>

          <!-- 自定义 -->
          <div class="recharge-item custom-item">
            <div class="item-left">
              <img src="@/assets/tiantong.png" class="sweet-icon" alt="甜筒" />
              <span class="sweet-count">{{ customAmount ? customAmount + '甜筒' : '自定义' }}</span>
            </div>
            <input
              v-model="customAmount"
              type="number"
              placeholder="xx"
              class="custom-input"
              @focus="selectedAmount = null"
            />
            <span class="custom-unit">元</span>
          </div>
        </div>

        <!-- 底部说明 -->
        <div class="recharge-footer">
          <p class="recharge-tips">甜筒将在支付成功后即时到账<br>账单显示：甜筒星球充值</p>
          <button class="btn-recharge" :class="{ loading: isRechargeLoading }" :disabled="isRechargeLoading" @click="confirmRecharge">
            <span v-if="isRechargeLoading" class="loading-spinner"></span>
            <span v-else>充值</span>
          </button>
        </div>
      </div>
    </div>

    <!-- 扫码支付弹窗 -->
    <div v-if="showPayModal" class="pay-modal-overlay" @click.self="closePayModal">
      <div class="pay-modal-content">
        <div class="pay-modal-header">
          <h3>微信支付</h3>
          <i class="el-icon-close" @click="closePayModal"></i>
        </div>
        <div class="pay-modal-body">
          <p class="pay-order-no">订单号：{{ payOrderNo }}</p>
          <div class="pay-qrcode">
            <!-- 使用qrcode.js生成二维码 -->
            <canvas ref="payQrCanvas"></canvas>
          </div>
          <p class="pay-tips">请使用微信扫一扫完成支付</p>
        </div>
      </div>
    </div>
 
    <!-- 提示去登录的弹窗 -->
    <div v-if="showLoginModal" class="login-modal-overlay" @click.self="closeLoginModal">
      <div class="login-modal-content">
        <div class="login-modal-header">
          <h3>欢迎加入甜筒星球</h3>
          <i class="el-icon-close" @click="closeLoginModal"></i>
        </div>
        <div class="login-modal-body">
          <p class="login-modal-desc">登录后即可解锁更多精彩功能：</p>
          <div class="login-features">
            <p class="feature-text">• 直播间实时评论互动，与主播零距离交流</p>
            <p class="feature-text">• 给喜欢的主播送礼物，表达你的支持</p>
            <p class="feature-text">• 关注主播，第一时间收到开播提醒</p>
            <p class="feature-text">• 申请成为主播，开启你的直播之旅</p>
            <p class="feature-text">• 参与直播间抽奖活动，赢取丰厚奖励</p>
            <p class="feature-text">• 查看直播回放，精彩不错过</p>
          </div>
          <p class="login-modal-tips">我们在甜筒星球等你，快来加入吧！</p>
        </div>
        <div class="login-modal-footer">
          <button class="btn-login-later" @click="closeLoginModal">稍后登录</button>
          <button class="btn-login-now" @click="goToLogin">去登录</button>
        </div>
      </div>
    </div>

    <!-- 未成年人保护提示弹窗（未登录时显示） -->
    <div v-if="showMinorProtectionModal" class="minor-modal-overlay" @click.self="closeMinorModal">
      <div class="minor-modal-content">
        <div class="minor-modal-header">
          <h3>未成年人保护</h3>
          <i class="el-icon-close" @click="closeMinorModal"></i>
        </div>
        <div class="minor-modal-body">
          <p class="minor-modal-desc">根据《中华人民共和国未成年人保护法》及相关法律法规要求，我们为未成年人提供专项保护措施。</p>
          <div class="minor-protection-info">
            <p class="minor-info-title">未成年人保护模式说明：</p>
            <p class="minor-info-item">• 每日观看时长严格限制在40分钟以内，超时将自动锁定</p>
            <p class="minor-info-item">• 每日22:00至次日06:00为禁播时段，期间无法访问平台</p>
            <p class="minor-info-item">• 全面关闭充值、消费、打赏、会员购买等付费功能</p>
            <p class="minor-info-item">• 限制评论、等社交互动功能</p>
            <p class="minor-info-item">• 智能过滤并隐藏不适宜未成年人观看的内容</p>
            <p class="minor-info-item">• 实名认证后自动识别未成年人身份并启用保护模式</p>
            <p class="minor-info-item">• 家长可以放心让孩子使用</p>
            <p class="minor-info-item">• 提供青少年专属内容推荐，健康向上、寓教于乐</p>
          </div>
          <p class="minor-modal-tips">我们致力于为未成年人营造安全、健康的网络环境，建议家长陪同未成年人一起使用本平台</p>
        </div>
        <div class="minor-modal-footer">
          <button class="btn-minor-later" @click="closeMinorModal">稍后登录开启</button>
          <button class="btn-minor-now" @click="goToLoginFromMinor">立即登录开启</button>
        </div>
      </div>
    </div>
 </div>
</template>

<script>
import axios from 'axios'
import QRCode from 'qrcode'
export default {
  name: 'homeT',
  data() {
    return {
      // 是否显示登录提示弹窗
      showLoginModal: false,
      // 是否显示未成年人保护弹窗
      showMinorProtectionModal: false,
      // 当前选中的导航
      activeNav: 'music',
      // 当前选中的菜单
      activeMenu: 'home',
      // 充值相关
      selectedAmount: 90,
      customAmount: '',
      // 扫码支付弹窗
      showPayModal: false,
      payOrderNo: '',
      payCodeUrl: '',
      // 充值按钮加载状态
      isRechargeLoading: false,
      rechargeList: [
        { count: 1, amount: 1 },
        { count: 10, amount: 10 },
        { count: 90, amount: 90 },
        { count: 100, amount: 100 },
        { count: 648, amount: 648 }
      ],
      // 导航列表
      navList: [
        { name: 'music', label: '音乐' },
        { name: 'instrument', label: '乐器' },
        { name: 'dance', label: '舞蹈' },
        { name: 'talkshow', label: '脱口秀' },
        { name: 'anime', label: '二次元' },
        { name: 'beauty', label: '颜值' },
        { name: 'talent', label: '才艺' },
        { name: 'lifestyle', label: '生活方式' },
        { name: 'groupdance', label: '团舞' },
        { name: 'cover', label: '翻唱' }
      ],
      // 基础菜单列表（始终显示）
      baseMenuList: [
        { name: 'home', label: '首页', icon: require('../assets/shoye_hui.png'), iconActive: require('../assets/shoye.png')},
        { name: 'discover', label: '发现精彩', icon:require('../assets/zhibo_hui.png'), iconActive:require('../assets/zhibo.png')},
        { name: 'live', label: '成为主播', icon: require('../assets/shipin_hui.png'), iconActive: require('../assets/shipin.png')},
        { name: 'settings', label: '设置', icon: require('../assets/gengduo_hui.png'), iconActive: require('../assets/gengduo.png')}
      ],
      // 登录后才显示的菜单
      profileMenu: { name: 'profile', label: '个人中心', icon: require('../assets/gr_hei.png'), iconActive: require('../assets/gr_liang.png') },
      // 推荐主播列表
      anchorList: []
    }
  },
  
  mounted() {
    // 检查用户是否已登录，未登录则显示登录提示弹窗
    if (!this.isLoggedIn) {
      this.showLoginModal = true
    }
    
    axios.get('https://ttxq.xiangyouhulian.cn/api/index/tuijianss').then(res => {
      console.log('推荐主播数据:', res.data.data)
      this.anchorList = res.data.data;
    }).catch(err => {
      console.error('获取推荐主播失败:', err)
    })
  },

  methods:{
    lanmu(item){
      this.activeMenu = item.name;
      // 设置和开启直播需要登录
      if(item.name === 'settings' || item.name === 'live'){
        if(!this.isLoggedIn){
          this.$message.warning('你还没有登录！');
          return;
        }
      }
      if(item.name === 'settings'){
        this.$router.push('/shezhi');
      } else if(item.name === 'home'){
        this.$router.push('/');
      } else if(item.name === 'discover'){
        // 1 ~ 5 随机整数，包含1和5
        // const num = Math.floor(Math.random() * 5) + 1;
        this.$router.push('/zbjc');
      } else if(item.name === 'live'){
        this.$router.push('/kaibo');
      } else if(item.name === 'profile'){
        this.$router.push('/gr');
      }
    },
    //推荐主播-跳转
    TuiJianClick(anchorid,id){
      console.log(anchorid,id);
      this.$router.push(`/zb/${id}/${anchorid}`);
    },
    // 选择充值金额
    selectAmount(item) {
      this.selectedAmount = item.amount
      this.customAmount = ''
    },
    // 打开充值弹窗
    openRecharge() {
      this.$store.commit('setVipshow', true)
    },
    // 关闭充值弹窗
    closeRecharge() {
      this.$store.commit('setVipshow', false)
    },
    // 关闭扫码支付弹窗
    closePayModal() {
      this.showPayModal = false
      this.payCodeUrl = ''
      this.payOrderNo = ''
    },
    // 生成支付二维码
    generateQrCode() {
      const canvas = this.$refs.payQrCanvas
      if (canvas && this.payCodeUrl) {
        QRCode.toCanvas(canvas, this.payCodeUrl, {
          width: 200,
          margin: 2,
          color: {
            dark: '#000000',
            light: '#ffffff'
          }
        }).catch(err => {
          console.error('生成二维码失败:', err)
        })
      }
    },
    //搜索
    Sousuo() {
      this.$router.push('/search');
    },
    // 关闭登录提示弹窗
    closeLoginModal() {
      this.showLoginModal = false
      // 如果用户未登录，关闭登录弹窗后显示未成年人保护弹窗
      if (!this.isLoggedIn) {
        this.showMinorProtectionModal = true
      }
    },
    // 关闭未成年人保护弹窗
    closeMinorModal() {
      this.showMinorProtectionModal = false
    },
    // 从未成年人弹窗去登录
    goToLoginFromMinor() {
      this.closeMinorModal()
      this.$router.push('/login')
    },
    // 处理子组件触发的显示未成年人保护弹窗事件
    handleShowMinorProtection() {
      console.log('handleShowMinorProtection called')
      this.showMinorProtectionModal = true
      console.log('showMinorProtectionModal:', this.showMinorProtectionModal)
    },
    // 去登录
    goToLogin() {
      this.closeLoginModal()
      this.$router.push('/login')
    },
    // 确认充值
    confirmRecharge() {
      const amount = this.selectedAmount || this.customAmount
      if (!amount) {
        this.$message.error('请选择或输入充值金额')
        return
      }
      // 设置加载状态，防止重复点击
      this.isRechargeLoading = true
      // 调用创建订单接口
      axios.post('https://ttxq.xiangyouhulian.cn/api/index/createNative', {
        money: amount*100
      }).then(res => {
        // 关闭加载状态
        this.isRechargeLoading = false
        if (res.data.code === 1 && res.data.code_url) {
          // 显示扫码支付弹窗
          this.payOrderNo = res.data.order_no
          this.payCodeUrl = res.data.code_url
          this.showPayModal = true
          // 生成二维码
          this.$nextTick(() => {
            this.generateQrCode()
          })
        } else {
          this.$message.error(res.data.msg || '创建订单失败')
        }
      }).catch(err => {
        // 关闭加载状态
        this.isRechargeLoading = false
        this.$message.error('网络错误，请稍后重试')
        console.log(err)
      })
    },
  },
  computed: {
    vipshow() {
      return this.$store.state.vipshow
    },
    // 是否已登录
    isLoggedIn() {
      return this.$store.state.LoginStorage && this.$store.state.LoginStorage.id
    },
    // 根据登录状态返回菜单列表
    menuList() {
      if (this.isLoggedIn) {
        // 已登录，显示个人中心
        return [...this.baseMenuList, this.profileMenu]
      }
      // 未登录，不显示个人中心
      return this.baseMenuList
    }
  }
}
</script>

<style scoped>
/* ==================== 整体布局 ==================== */
.home_box {
  width: 100%;
  min-height: 100vh;
  background-color: #FBFAFF;
  /* margin: 0 auto; */
}

/* ==================== 顶部导航栏 ==================== */
.header {
  display: flex;
  align-items: center;
  height: 64px;
  padding: 0 24px;
  background-color: #FFFFFF;
  /* border-bottom: 1px solid #DED5FF; */
}

/* Logo区域 */
.logo {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 301px;
  margin-bottom:20px;
  cursor: pointer;
}

.logo_img {
  width: 135px;
  margin-right: 8px;
}

.logo_text {
  font-size: 20px;
  font-weight: 600;
  color: #8A3FFC;
}

/* 导航区域 */
.nav {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex: 1;
  padding-right: 16px;
}

.nav_item {
  padding: 8px 12px;
  font-size: 14px;
  color: #4B3B73;
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap;
  position: relative;
}

.nav_item:hover {
  color: #8A3FFC;
}


.nav_item.active {
  color: #8A3FFC;
  font-weight: 500;
}

.nav_item.active::after {
  content: '';
  position: absolute;
  bottom: -8px;
  left: 50%;
  transform: translateX(-50%);
  width: 24px;
  height: 3px;
  background-color: #8A3FFC;
  border-radius: 2px;
}

/* 更多按钮 */
.nav_more {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  margin-left: 8px;
  color: #7C6AAE;
  cursor: pointer;
  border-radius: 50%;
  transition: all 0.3s ease;
}

.nav_more:hover {
  background-color: #ECE6FF;
}

/* 登陆按钮 */
.login_btn {
  margin-left: auto;
  padding: 8px 24px;
  font-size: 14px;
  color: #8A3FFC;
  background-color: transparent;
  border: 1px solid #8A3FFC;
  border-radius: 20px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.login_btn:hover {
  color: #FFFFFF;
  background-color: #8A3FFC;
}

/* ==================== 主内容区域 ==================== */
.main_container {
  display: flex;
  height: calc(100vh);
}

/* ==================== 左侧栏目 ==================== */
.sidebar {
  display: flex;
  flex-direction: column;
  /* width: 240px; */
  padding: 16px 16px;
  background-color: #FFFFFF;
  /* border-right: 1px solid #DED5FF; */
  overflow-y: auto;
  /* padding-left: 15%; */
}

/* 搜索框 */
.search_box {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  margin-bottom: 18px;
  background-color: #F9F7FF;
  border: solid 1px #DED5FF;
  border-radius: 24px;
}

.search_icon {
  margin-right: 8px;
  font-size: 16px;
  color: #9B8DC7;
}

.search_input {
  flex: 1;
  font-size: 14px;
  color: #5B4B7A;
  background: transparent;
  border: none;
  outline: none;
}

.search_input::placeholder {
  color: #9B8DC7;
}

/* 菜单列表 */
.menu_list {
  margin-bottom: 16px;
}

.menu_item {
  display: flex;
  align-items: center;
  padding: 10px 16px;
  margin-bottom: 4px;
  cursor: pointer;
  border-radius: 10px;
  transition: all 0.3s ease;
}

.menu_item:hover {
  background-color: #F9F7FF;
}

.menu_item.active {
  background-color: #ECE6FF;
}

.menu_icon {
  margin-right: 12px;
  width: 20px;
  height: 20px;
  object-fit: contain;
  vertical-align: middle;
}

.menu_text {
  font-size: 16px;
  color: #9B8DC7;
  vertical-align: middle;
  line-height: 20px;
}

.menu_item.active .menu_text {
  color: #8A3FFC;
  font-weight: 500;
}



/* 侧边栏登陆按钮 */
.sidebar_login_btn {
  width: 100%;
  padding: 12px 0;
  margin-bottom: 24px;
  font-size: 14px;
  color: #FFFFFF;
  background: linear-gradient(135deg, #8A3FFC 0%, #A855F7 100%);
  border: none;
  border-radius: 24px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.sidebar_login_btn:hover {
  opacity: 0.9;
  transform: translateY(-1px);
}

/* 推荐主播区域 */
.recommend_section {
  padding-top: 16px;
  padding: 16px 16px;
  border-top: 1px solid #DED5FF;
}

.section_title {
  margin-bottom: 5px;
  font-size: 16px;
  font-weight: 600;
  color: #4B3B73;
}

.anchor_list {
  list-style: none;
}

.anchor_item {
  display: flex;
  align-items: center;
  padding: 8px 0;
  cursor: pointer;
}

.anchor_avatar_wrap {
  position: relative;
  width: 48px;
  height: 48px;
  margin-right: 12px;
  flex-shrink: 0;
  border-radius: 50%;
  overflow: visible;
  padding: 2.5px;
  border: 2px solid #ff493f;
}

.anchor_avatar {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  border-radius: 50%;
}

.live_badge {
  position: absolute;
  bottom: -6px;
  left: 50%;
  transform: translateX(-50%);
  padding: 2px 8px;
  font-size: 12px;
  color: #FFFFFF;
  background: #FF1493;
  border-radius: 10px;
  white-space: nowrap;
  font-weight: 500;
}

.anchor_info {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.anchor_name {
  width: 200px;
  /* 溢出隐藏 */
  overflow: hidden;
  /* 不让文本换行 除非遇到br标签 */
  white-space:nowrap;
  /* 溢出文字用...代替 */
  text-overflow: ellipsis;
  font-size: 15px;
  font-weight: 500;
  color: #181426;
  margin-bottom: 2px;
}

.anchor_subtitle {
  font-size: 14px;
  color: #9B8DC7;
}

.anchor_tag {
  font-size: 12px;
  color: #9B8DC7;
}

/* 公司信息区域 */
.company_section {
  margin-top: auto;
  padding-top: 16px;
  border-top: 1px solid #DED5FF;
}

.company_links {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 8px;
}

.company_link {
  font-size: 12px;
  color: #9B8DC7;
  text-decoration: none;
  transition: color 0.3s ease;
}

.company_link:hover {
  color: #8A3FFC;
}

.company_copyright {
  font-size: 12px;
  color: #9B8DC7;
}

/* ==================== 充值弹窗 ==================== */
.recharge-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1000;
  display: flex;
  justify-content: flex-end;
}

.recharge-panel {
  width: 360px;
  height: 100%;
  background: #fff;
  display: flex;
  flex-direction: column;
  animation: slideIn 0.3s ease;
}

@keyframes slideIn {
  from {
    transform: translateX(100%);
  }
  to {
    transform: translateX(0);
  }
}

.recharge-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid #f0f0f0;

  .recharge-title {
    font-size: 18px;
    font-weight: 600;
    color: #333;
    margin: 0;
  }

  .el-icon-close {
    font-size: 20px;
    color: #999;
    cursor: pointer;

    &:hover {
      color: #666;
    }
  }
}

.recharge-options {
  flex: 1;
  padding: 24px;
  overflow-y: auto;
}

.recharge-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 20px;
  margin-bottom: 12px;
  background: #f8f8ff;
  border: 2px solid transparent;
  border-radius: 50px;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background: #f0f0ff;
  }

  &.active {
    background: #8B5CF6;
    border-color: #8B5CF6;

    .sweet-count{
      color: #fff;
    }
    .item-price {
      color: #fff;
    }
  }

  .item-left {
    display: flex;
    align-items: center;
    gap: 12px;

    .sweet-icon {
      width: 24px;
      height: 33px;
    }

    /* .sweet-count {
      font-size: 15px;
      color: #333;
      font-weight: 500;
    } */
  }

  .item-price {
    font-size: 15px;
    color: #333;
    font-weight: 500;
  }
}

.custom-item {
  .custom-input {
    width: 60px;
    padding: 4px 8px;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    font-size: 14px;
    text-align: center;
    outline: none;
    background: #fff;

    &:focus {
      border-color: #8B5CF6;
    }
  }

  .custom-unit {
    font-size: 14px;
    color: #666;
    margin-left: 4px;
  }
}

.recharge-footer {
  padding: 20px 24px;
  border-top: 1px solid #f0f0f0;

  .recharge-tips {
    font-size: 12px;
    color: #999;
    text-align: center;
    margin: 0 0 16px 0;
    line-height: 1.6;
  }

  .btn-recharge {
    width: 100%;
    padding: 14px 0;
    background: #8B5CF6;
    border: none;
    border-radius: 28px;
    color: #fff;
    font-size: 16px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
      opacity: 0.9;
    }

    /* 加载状态 */
    &.loading {
      background: #ccc;
      cursor: not-allowed;

      &:hover {
        opacity: 1;
      }
    }

    /* 加载动画 */
    .loading-spinner {
      width: 20px;
      height: 20px;
      border: 2px solid #fff;
      border-top-color: transparent;
      border-radius: 50%;
      animation: spin 0.8s linear infinite;
    }
  }

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
}

/* ==================== 未成年人保护弹窗 ==================== */
.minor-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 3001;
  display: flex;
  align-items: center;
  justify-content: center;
}

.minor-modal-content {
  width: 420px;
  background: #fff;
  border-radius: 16px;
  overflow: hidden;
  animation: fadeIn 0.3s ease;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2);
}

.minor-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 28px;
  border-bottom: 1px solid #f0f0f0;

  h3 {
    font-size: 18px;
    font-weight: 600;
    color: #333;
    margin: 0;
  }

  .el-icon-close {
    font-size: 18px;
    color: #999;
    cursor: pointer;

    &:hover {
      color: #666;
    }
  }
}

.minor-modal-body {
  padding: 24px 28px;

  .minor-modal-desc {
    font-size: 14px;
    color: #555;
    margin-bottom: 16px;
    line-height: 1.6;
  }

  .minor-protection-info {
    background: #f8f8ff;
    border-radius: 12px;
    padding: 20px;
    border-left: 3px solid #8A3FFC;
    margin-bottom: 16px;

    .minor-info-title {
      font-size: 14px;
      color: #333;
      margin: 0 0 12px 0;
      font-weight: 600;
    }

    .minor-info-item {
      font-size: 13px;
      color: #555;
      line-height: 2;
      margin: 0;
    }
  }

  .minor-modal-tips {
    font-size: 12px;
    color: #999;
    margin: 0;
    line-height: 1.5;
  }
}

.minor-modal-footer {
  padding: 0 28px 28px;
  display: flex;
  gap: 12px;

  .btn-minor-later {
    flex: 1;
    padding: 14px 0;
    background: #f5f5f5;
    border: none;
    border-radius: 10px;
    color: #666;
    font-size: 15px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
      background: #e8e8e8;
    }
  }

  .btn-minor-now {
    flex: 1;
    padding: 14px 0;
    background: linear-gradient(135deg, #8A3FFC 0%, #A855F7 100%);
    border: none;
    border-radius: 10px;
    color: #fff;
    font-size: 15px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
      opacity: 0.9;
    }
  }
}

/* ==================== 登录提示弹窗 ==================== */
.login-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 3000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.login-modal-content {
  width: 400px;
  background: linear-gradient(145deg, #2d1b4e 0%, #1a0f2e 100%);
  border-radius: 16px;
  overflow: hidden;
  animation: fadeIn 0.3s ease;
  box-shadow: 0 25px 80px rgba(138, 63, 252, 0.4);
  border: 1px solid rgba(138, 63, 252, 0.2);
}

.login-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 28px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);

  h3 {
    font-size: 18px;
    font-weight: 600;
    color: #fff;
    margin: 0;
  }

  .el-icon-close {
    font-size: 18px;
    color: rgba(255, 255, 255, 0.6);
    cursor: pointer;

    &:hover {
      color: #fff;
    }
  }
}

.login-modal-body {
  padding: 28px;

  .login-modal-desc {
    font-size: 15px;
    color: rgba(255, 255, 255, 0.9);
    margin-bottom: 16px;
  }

  .login-features {
    margin-bottom: 20px;

    .feature-text {
      font-size: 14px;
      color: rgba(255, 255, 255, 0.75);
      line-height: 2.2;
      margin: 0;
    }
  }

  .login-modal-tips {
    font-size: 13px;
    color: rgba(255, 255, 255, 0.5);
    margin: 0;
    padding-top: 16px;
    border-top: 1px solid rgba(255, 255, 255, 0.1);
  }
}

.login-modal-footer {
  padding: 0 28px 28px;
  display: flex;
  gap: 12px;

  .btn-login-now {
    flex: 1;
    padding: 14px 0;
    background: linear-gradient(135deg, #8A3FFC 0%, #A855F7 100%);
    border: none;
    border-radius: 10px;
    color: #fff;
    font-size: 15px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
      opacity: 0.9;
    }
  }

  .btn-login-later {
    flex: 1;
    padding: 14px 0;
    background: rgba(255, 255, 255, 0.1);
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 10px;
    color: rgba(255, 255, 255, 0.8);
    font-size: 15px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
      background: rgba(255, 255, 255, 0.15);
      color: #fff;
    }
  }
}

/* ==================== 扫码支付弹窗 ==================== */
.pay-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.pay-modal-content {
  width: 360px;
  background: #fff;
  border-radius: 16px;
  overflow: hidden;
  animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: scale(0.9);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

.pay-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid #f0f0f0;

  h3 {
    font-size: 18px;
    font-weight: 600;
    color: #333;
    margin: 0;
  }

  .el-icon-close {
    font-size: 20px;
    color: #999;
    cursor: pointer;

    &:hover {
      color: #666;
    }
  }
}

.pay-modal-body {
  padding: 24px;
  text-align: center;

  .pay-order-no {
    font-size: 13px;
    color: #999;
    margin-bottom: 16px;
  }

  .pay-qrcode {
    display: flex;
    justify-content: center;
    margin-bottom: 16px;

    canvas {
      border-radius: 8px;
    }
  }

  .pay-tips {
    font-size: 14px;
    color: #666;
  }
}

/* ==================== 内容区域 ==================== */
.content {
  flex: 1;
 /* padding-right: 15%;*/
  overflow-y: auto;
  background-color: #FBFAFF;
  /* padding: 0 60px; */
}
</style>
